import React from 'react'
import { connect } from 'react-redux'
import * as general from '../../constants/General'
import * as settings from '../../constants/appsettings.json';
import ItemButton from '../../components/ItemButton'
import { getPos } from '../../actions/dataActions'

class ChargingKiosk extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        kiosktext: {__html: 'Een moment geduld alstublieft.'}
    };
  }

  componentDidMount() {
    fetch(`${general.API_URL_GET_KIOSKTEXT}/${this.props.posid}`, {
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => this.setState({kiosktext: {__html: data}}));
  }

  renderItemButtonComponents() {
    const {
      groups
    } = this.props;

    let rasterx = 4
    let rastery = 1
    let keys = [];

    for (let i = 0; i < groups.length; i++) {
      const item = groups[i]
      rasterx = item.RasterX
      rastery = item.RasterY
      keys = item.KeyLayoutItems
    }

    const datagrid = {
      x: rasterx,
      y: rastery
    }

    const defaultbtnwidth = 100.0 / datagrid.x
    const defaultbtnheight = 100.0 / datagrid.y
    const drawbtns = []

    keys.map(key => {
      const btnwidth = defaultbtnwidth * key.Width
      const btnheight = defaultbtnheight * key.Height

      const btntop = (defaultbtnheight * (key.LocationY + 1)) - defaultbtnheight
      const btnleft = (defaultbtnwidth * (key.LocationX + 1)) - defaultbtnwidth

      drawbtns.push({
        id: key.KeyLayoutItemId,
        itemvalue: key.ItemValue,
        itemtype: key.ItemType,
        itemparam: key.ItemParam,
        description: key.Description,
        color: key.Color,
        width: btnwidth,
        height: btnheight,
        top: btntop,
        left: btnleft,
        fileAttachmentId: key.FileAttachmentId
      })
      return ''
    });

    return (
      drawbtns.map(btn =>
        <ItemButton
          key={btn.id}
          id={btn.id}
          itemvalue={btn.itemvalue}
          itemtype={btn.itemtype}
          itemparam={btn.itemparam}
          text={btn.description}
          color={btn.color}
          btnwidth={btn.width}
          btnheight={btn.height}
          btntop={btn.top}
          btnleft={btn.left}
          price={btn.price}
          configurationsteps={btn.configurationsteps}
          fileAttachmentId={btn.fileAttachmentId}
        />
      )
    );
  }

  render() {
    const { 
      customer, 
      posid
    } = this.props;

    const style = {
      backgroundImage: `url(${settings.API_URL}pos/getkioskbackground/${posid})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    }

    const kiosktext = this.state.kiosktext;

    let textColorStyle = {};
    const pos = this.props.getPos(posid);
    if (pos !== null)
    {
      textColorStyle = {
        color: pos.KioskTextColor
      }
    }

    return (
      <div className="container" style={style}>
        { 
          (customer && customer.customerid > 0) ? <div className="kiosk-buttons-container">
            <div key={1} style={textColorStyle}>{`${customer.customerName} - Saldo: ${customer.customerSaldo.toFixed(2).replace('.', ',')}`}</div>
            <div key={2} className="kiosk-buttons-container">{
              this.renderItemButtonComponents()
            }</div>
            </div> : 
            <div className="chargingkiosk-message" key={0} dangerouslySetInnerHTML={kiosktext}></div>
        }
      </div>)
  }
}

function mapStateToProps(state) {
  return {
    groups: state.layoutState.groups.items,
    customer: state.receiptState.receipt.customer,
    posid: state.generalState.posId
  }
}

export default connect(mapStateToProps, { getPos })(ChargingKiosk)



// WEBPACK FOOTER //
// src/kiosk/components/ChargingKiosk.jsx